<template>
  <v-list-tile ripple :to="to" exact>
    <v-list-tile-action v-if="icon">
      <v-icon :color="iconColor" small v-if="icon">{{ icon }}</v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      <v-list-tile-title>{{ text }}</v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
export default {
  props: ["to", "icon", "text", "iconColor"]
};
</script>

<style scoped>
/* div >>> .v-list__tile {
  box-shadow: 0px 1px 1px #88888840;
} */
</style>
